var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-fill d-flex",attrs:{"id":"app"}},[(_vm.$store.state.currentUser)?_c('Navigation'):_vm._e(),_c('router-view',{staticClass:"d-flex flex-fill flex-column content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }